import { AuthErrors } from './errors'
import { QueryKeys } from './queryKeys'
import { isEmailAvailable } from './views'
import { firebase } from '@/services/firebase'
import { appStatusStore } from '@/stores'

export function useLogin() {
  const login = async (email: string, password: string) => {
    appStatusStore.set('loading')

    try {
      const emailAvailable = await isEmailAvailable(email)

      if (emailAvailable) {
        AuthErrors.exception('auth/email-not-found')
      }

      await firebase.auth.signInWithEmailAndPassword(email.trim(), password.trim())

      await QueryKeys.me.refresh()

      const currentUser = firebase.auth.currentUser

      await currentUser.reload()

      appStatusStore.set('done')
      return true
    } catch (err) {
      appStatusStore.set('idle')
      AuthErrors.onError(err, 'login')
      return false
    }
  }

  return login
}